const hasOwnProperty = Object.prototype.hasOwnProperty;

export function hasOwn<T extends object>(object: T, key: PropertyKey): key is keyof T {
    return hasOwnProperty.call(object, key);
}
